// Account Payable Payments Getters

export const getPaymentList = state => {
  return state.paymentList
}

export const getPaymentInfo = state => {
  return state.paymentInfo
}
